<template>
  <div class="skin-analysis-page">
    <van-nav-bar
      title="皮肤类型"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      safe-area-inset-top
    />

    <div class="teal-bg">
      <!-- 原理说明卡片 -->
      <div class="card-container introduce-card">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/原理说明.png" alt="原理说明" class="header-icon" />
          <span class="header-title">原理说明</span>
        </div>
        <div class="introduce-text">
          {{ introduce }}
        </div>
      </div>

      <!-- 皮肤类型卡片 -->
      <div class="card-container list-card">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/皮肤类型.png" alt="皮肤类型" class="header-icon" />
          <span class="header-title">皮肤类型</span>
        </div>

        <div class="list-wrapper">
          <div class="list-item" v-for="(item, index) in list" :key="index">
            <!-- 1. 标题行 -->
            <div class="item-header">
              <div class="title-left">
                <img :src="item.icon || defaultIcon" class="item-icon" />
                <span class="item-name">{{ item.name }}</span>
                <span class="item-lab" v-if="item.lab">{{ item.lab }}</span>
              </div>
            </div>

            <!-- 2. 示例图与图例 (如果有) -->
            <div class="example-section" v-if="item.exampleImg || (item.example && item.example.length)">
              <div class="example-img-wrapper" v-if="item.exampleImg">
                <img :src="item.exampleImg" class="example-img" />
              </div>
              <div class="example-legends" v-if="item.example && item.example.length">
                <div class="legend-item" v-for="(leg, lIndex) in item.example" :key="lIndex">
                  <span class="legend-dot" :style="{ backgroundColor: leg.color }"></span>
                  <span class="legend-name">{{ leg.name }}</span>
                </div>
              </div>
            </div>

            <!-- 3. 严重程度 -->
            <div class="severity-section">
              <div class="severity-title">严重程度</div>
              <div class="severity-bars">
                <div class="severity-col" v-for="(lvl, lIdx) in levels" :key="lIdx">
                  <div class="bar" :style="{ backgroundColor: lvl.color }">
                    <div class="active-indicator" v-if="item.level === lvl.name" :style="{ borderColor: lvl.color }"></div>
                  </div>
                  <div class="bar-label">{{ lvl.name }}</div>
                </div>
              </div>
            </div>

            <!-- 4. 指导建议 -->
            <div class="device-section">
              <span class="device-label">指导建议：</span>
              <span class="device-text">{{ item.device }}</span>
            </div>

            <!-- 5. 虚线分割线 (最后一个不显示) -->
            <div class="dashed-divider" v-if="index !== list.length - 1"></div>
          </div>
        </div>
      </div>
      
      <!-- 底部声明与时间 -->
      <div class="bottom-statement">
        <div class="statement-text">
          重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论，如已有身体不适，请及时咨询医生。
        </div>
        <div class="time-text" v-if="createAt">
          生成时间：{{ formatTime(createAt) }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { NavBar } from 'vant';

export default {
  name: 'MyAiSkinAnalysis',
  components: {
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      introduce: '',
      list: [],
      createAt: '',
      // 默认的图标，如果没有的话
      defaultIcon: 'https://uat-yeahgo-oss.yeahgo.com/wechat/scanBoot/default_icon.png', // 可以替换为实际存在的默认图标
      levels: [
        { name: '无', color: '#75CAE2' },
        { name: '轻度', color: '#92CF9C' },
        { name: '中度', color: '#FF8C58' },
        { name: '重度', color: '#FF5001' }
      ]
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    loadData() {
      const dataStr = sessionStorage.getItem("MY_AI_SKIN_ANALYSIS");
      if (dataStr) {
        try {
          const data = JSON.parse(dataStr);
          this.createAt = data.createAt || '';
          if (data.skinAnalysis) {
            this.introduce = data.skinAnalysis.introduce || '';
            this.list = data.skinAnalysis.list || [];
          }
        } catch (e) {
          console.error("解析皮肤分析数据失败", e);
        }
      }
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      try {
        const parts = timeStr.split(' ');
        const dateParts = parts[0].split('-');
        return `${dateParts[0]}年${parseInt(dateParts[1], 10)}月${parseInt(dateParts[2], 10)}日 ${parts[1] || ''}`;
      } catch (e) {
        return timeStr;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.skin-analysis-page {
  background: #44C2C4;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.teal-bg {
  flex: 1;
  background: #44C2C4;
  padding: 16px 12px;
}

.card-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-bottom: 16px;
}

.card-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.header-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* 原理说明 */
.introduce-text {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

/* 列表卡片 */
.list-card {
  padding: 20px 12px;
}

.list-item {
  display: flex;
  flex-direction: column;
}

/* 1. 标题行 */
.item-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.title-left {
  display: flex;
  align-items: center;
}

.item-icon {
  width: 40px;
  height: 40px;
  margin-right: 0;
  object-fit: cover;
}

.item-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-right: 12px;
}

.item-lab {
  background: #85D697;
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 8px 0 8px 0; /* 左上、右下圆角 */
  line-height: 1.2;
}

/* 2. 示例图区 */
.example-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
}

.example-img-wrapper {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  overflow: hidden;
  background: #f0f0f0;
  margin-bottom: 12px;
}

.example-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.placeholder-img {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 12px;
}

.example-legends {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 12px;
}

.legend-item {
  display: flex;
  align-items: center;
  background: #f7f8fa;
  padding: 4px 10px;
  border-radius: 6px;
}

.legend-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

.legend-name {
  font-size: 13px;
  color: #333;
}

/* 3. 严重程度 */
.severity-section {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.severity-title {
  font-size: 15px;
  font-weight: bold;
  color: #333;
  margin-bottom: 16px;
}

.severity-bars {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.severity-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bar {
  width: 100%;
  height: 8px;
  border-radius: 4px;
  position: relative;
  margin-bottom: 8px;
}

.active-indicator {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  border: 2px solid; /* 颜色在行内样式中设置 */
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bar-label {
  font-size: 12px;
  color: #666;
}

/* 4. 指导建议 */
.device-section {
  background: #f7f8fa;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 20px;
}

.device-label {
  font-weight: bold;
  color: #333;
}

.device-text {
  color: #666;
}

/* 底部声明 */
.bottom-statement {
  padding: 16px 12px;
  margin-top: 8px;
}

.statement-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  text-align: justify;
}

.time-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 8px;
  text-align: center;
}

/* 5. 虚线分割线 */
.dashed-divider {
  width: 100%;
  border-top: 1px dashed #e5e5e5;
  margin-bottom: 20px;
}
</style>
